import urlConfig from "../../config.json";
import { BACKEND_URL } from "../../constants";
import { axios } from "../../utils/axiosConfig";
import { handleApiError } from "../scopedListFetch";

export const editCompany = async (reqData) => {
  const ROUTE = urlConfig.backend.routes.companies.updateCompany;
  const url = `${BACKEND_URL}${ROUTE}`;

  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };

  return await axios
    .put(url, reqData, config)
    .then((res) => {
      if (res.status === 200) {
        return { res: res.data, error_code: 1 };
      }
      return {
        error_code: 2,
        error_message: "Something Went Wrong please try again later",
      };
    })
    .catch((error) => handleApiError(error));
};
